module.exports = __webpack_public_path__ + "static/media/baijani.bffa0645.png";